/* eslint-disable max-len */
import dayjs from 'dayjs';

export const listMock = [
  {
    id: '1',
    member: {
      name: 'john_doe',
      fullname: 'John Doe',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
      'Consectetur adipisicing elit Lorem ipsum dolor sit amet, consectetur adipisicing elit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
  {
    id: '2',
    member: {
      name: 'Eliah',
      fullname: 'Eliah Johnson',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(2, 'd').toISOString(),
  },
  {
    id: '3',
    member: {
      name: 'Alisa',
      fullname: 'Alisa Hester',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
  {
    id: '4',
    member: {
      name: 'Lana',
      fullname: 'Lana Stevens',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
  {
    id: '5',
    member: {
      name: 'Natali',
      fullname: 'Natali Craig',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
  {
    id: '6',
    member: {
      name: 'Zahir',
      fullname: 'Zahir Mays',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
  {
    id: '7',
    member: {
      name: 'Lucky Loki',
      fullname: 'Loki Bright',
      thumbnail: 'https://i.pravatar.cc/300',
    },
    description:
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    items: [
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do',
      'Velit officia consequat duis enim velit mollit',
    ],
    createdDate: dayjs().subtract(1, 'd').toISOString(),
  },
];
